import React from "react";
import { useState, useEffect }  from "react";
import { Link } from "react-router-dom";
import Tender from "./Tender";
import {getTranslations} from './Translations'

export default function TenderListWithDetails(){

    const [tenders, setTenders] = useState([])
     let translations;
    useEffect(() => {
        translations = getTranslations(window.HRMRecruitmentComponentConfiguration?.language);
        fetch("list.json").then(res => res.json()).then((result) => {
            setTenders(result);
          },(error) => {
          }
        )
                       
    }, [])

    function renderColumn(tender, col) {

        let link = "/tender/" + tender.Id + "/" + tender.Name;

        switch(col.Type) {

            case 'Button':
                return  (
                    <div className={col.Class}>
                        <a href={tender[col.Key].Target}><button>{tender[col.Key].Text}</button></a>
                    </div>
                    )
            case 'Link':
                return  (
                    <div className={col.Class}>
                        <a href={tender[col.Key].Target}>{tender[col.Key].Text}</a>
                    </div>
                    )
            case 'DetailsLink':
                return  (
                    <div className={col.Class}>
                        <Link to={link}>
                            <>{tender[col.Key]}</>
                        </Link>
                    </div>
                )
            default:
                return  (
                    <div className={col.Class}>
                        {tender[col.Key]}
                    </div>                       
                )
        }
    }

    if(tenders?.Columns == null)
    {
        return (
            <div>{translations?.noTenders}</div>
        );
    }

    return (
        <>
        <div class="container">
            <div class="row">
                {tenders.Columns.map((column, i) => (
                    <div className={column.Class}>{column.Title}</div>
                ))}
            </div>
            
            {tenders.Tenders.map((tender, i) => (
                <div class="row" key={tender.Id}>
                        {tenders.Columns.map((col, j) => (
                        <>
                            {renderColumn(tender, col)}
                        </>
                    ))}
                </div>    
            ))}

        </div>

        <br />
        <br />

        <Tender />

        </>
    )

    
}
